import { safeFetch } from "../utils/safeFetch";

export const getStatsSales = async (token, tenant) => {
  const res = await safeFetch(`/api/stats/sales`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant
    }
  });
  if (!res.ok) throw new Error('Errore nel recupero vendite');
  return await res.json();
};

export const getStatsProducts = async (token, tenant) => {
  const res = await safeFetch(`/api/stats/products`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant
    }
  });
  if (!res.ok) throw new Error('Errore nel recupero prodotti');
  return await res.json();
};
